import client from "../../client";
import clientAuth from "../../clientAuth";
export default {
  get_users_list: () => clientAuth.get(`admin/coupons/eligible-users`),
  store: (couponData) =>
    clientAuth.post(`admin/coupons/store`, { json: couponData }),
  index: (page = 1) => clientAuth.get(`admin/coupons/index?page=${page}`),
  //   index: () => clientAuth.get(`admin/coupons/index`),
  destroy: (id) => clientAuth.delete(`admin/coupons/destroy/${id}`),
  show: (id) => clientAuth.get(`admin/coupons/show/${id}`),
};
